import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

export const Person:React.FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path d="M20 21.9155C20 20.52 20 19.8222 19.8278 19.2544C19.44 17.976 18.4395 16.9756 17.1611 16.5878C16.5933 16.4155 15.8956 16.4155 14.5 16.4155H9.5C8.10444 16.4155 7.40665 16.4155 6.83886 16.5878C5.56045 16.9756 4.56004 17.976 4.17224 19.2544C4 19.8222 4 20.52 4 21.9155M16.5 8.41553C16.5 10.9008 14.4853 12.9155 12 12.9155C9.51472 12.9155 7.5 10.9008 7.5 8.41553C7.5 5.93025 9.51472 3.91553 12 3.91553C14.4853 3.91553 16.5 5.93025 16.5 8.41553Z" stroke="currentColor" fill="transparent" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </SvgIcon>
)
